import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { map, pipe } from 'rxjs';

import { LocationType } from 'app/shared/features/location-selector/models';

import { locationsFeatureKey, LocationsState } from './locations.reducer';

export const selectLocationsState = createFeatureSelector<LocationsState>(locationsFeatureKey);

export const selectLocations = createSelector(selectLocationsState, (state) => state.locations);

export const getLocationsTypeGreenhouse = createSelector(selectLocations, (locations) =>
    locations.filter((location) => location.locationType === LocationType.Greenhouse),
);

export const getLocationsTypePackhouse = createSelector(selectLocations, (locations) =>
    locations.filter((location) => location.locationType === LocationType.Packhouse),
);

export const getLocationsTypePackage = createSelector(selectLocations, (locations) =>
    locations.filter((location) => location.locationType === LocationType.Package),
);

export const getLocationsTypeGeneric = createSelector(selectLocations, (locations) =>
    locations.filter((location) => location.locationType === LocationType.Generic),
);

export const getLocationsTypeCrop = createSelector(selectLocations, (locations) =>
    locations.filter((location) => location.locationType === LocationType.Crop),
);

export const getLocationsTypeDoor = createSelector(selectLocations, (locations) =>
    locations.filter((location) => location.locationType === LocationType.Door),
);

export const selectLocationByNumber = (locationNumber: number) =>
    pipe(
        select(selectLocations),
        map((locations) => locations.find((location) => location?.number === locationNumber)),
    );

export const selectLocationNameByNumber = (locationNumber: number | undefined) =>
    createSelector(
        selectLocations,
        (locations) => locations.find((location) => location.number === locationNumber)?.name,
    );
